import { ensureThemeJsonArray } from "../../functions/themeAssets";

/** Visual styling per option slot (labels come from theme per question). */
export const QUIZ_CHOICE_SLOTS = [
  { key: "option_one", cardBg: "#e8f8ee", accent: "#3dbb6d" },
  { key: "option_two", cardBg: "#fff8e6", accent: "#f0b429" },
  { key: "option_three", cardBg: "#fdeef2", accent: "#e87b8c" },
];

export function getChoiceSlotsForQuestion(question) {
  return QUIZ_CHOICE_SLOTS.map((slot) => ({
    ...slot,
    label: String(question[slot.key] ?? "").trim(),
  })).filter((slot) => slot.label);
}

function parseOptionPoints(raw, fallback = 1) {
  const n = Number(raw);
  return Number.isFinite(n) && n >= 0 ? Math.trunc(n) : fallback;
}

export function getPointsForChoice(question, choiceKey) {
  const pointsKey = `${choiceKey}_points`;
  return parseOptionPoints(question?.[pointsKey], 1);
}

export function parseQuizFromTheme(themeData) {
  const themeDefault = Number(themeData?.points);
  const defaultPoints =
    Number.isFinite(themeDefault) && themeDefault > 0
      ? Math.trunc(themeDefault)
      : 1;

  const raw = ensureThemeJsonArray(themeData?.quiz);
  return raw
    .map((item) => ({
      question: String(item?.question_name ?? item?.question ?? "").trim(),
      option_one: String(item?.option_one ?? "").trim(),
      option_one_points: parseOptionPoints(item?.option_one_points, defaultPoints),
      option_two: String(item?.option_two ?? "").trim(),
      option_two_points: parseOptionPoints(item?.option_two_points, defaultPoints),
      option_three: String(item?.option_three ?? "").trim(),
      option_three_points: parseOptionPoints(item?.option_three_points, defaultPoints),
      correct_answer: String(item?.correct_answer ?? "").trim(),
    }))
    .filter((q) => q.question && q.option_one && q.option_two && q.option_three);
}

export function normalizeAnswer(val) {
  return String(val ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

export function isCorrectChoice(question, choiceKey) {
  const selected = question[choiceKey];
  return normalizeAnswer(selected) === normalizeAnswer(question.correct_answer);
}
